import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Sparkle } from "@phosphor-icons/react";

export default function NewTemplateDialog({ open, onOpenChange, form, setForm, busy, onSubmit }) {
  const up = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gf-sharp border-zinc-200 max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-display font-bold tracking-tight">New template</DialogTitle>
          <DialogDescription>$10-$15 business-startup guide.</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label className="gf-overline">Title</Label>
            <Input data-testid="new-tpl-title" value={form.title} onChange={up("title")}
              className="gf-sharp mt-2 border-zinc-300 bg-white" />
          </div>
          <div>
            <Label className="gf-overline">Summary</Label>
            <Textarea data-testid="new-tpl-summary" rows={2} value={form.summary} onChange={up("summary")}
              className="gf-sharp mt-2 border-zinc-300 bg-white" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="gf-overline">Category</Label>
              <Input data-testid="new-tpl-category" value={form.category} onChange={up("category")}
                className="gf-sharp mt-2 border-zinc-300 bg-white" />
            </div>
            <div>
              <Label className="gf-overline">Price (USD)</Label>
              <Input data-testid="new-tpl-price" type="number" min="10" max="15" step="1"
                value={form.price_usd} onChange={up("price_usd")}
                className="gf-sharp mt-2 border-zinc-300 bg-white" />
            </div>
          </div>
          <div className="flex items-center justify-between border border-zinc-200 p-3 bg-zinc-50">
            <div className="flex items-center gap-2">
              <Sparkle size={16} />
              <span className="text-sm font-semibold">AI-seed content (Claude Sonnet 4.5)</span>
            </div>
            <Switch
              data-testid="new-tpl-ai-seed"
              checked={form.ai_seed}
              onCheckedChange={(v) => setForm((f) => ({ ...f, ai_seed: v }))}
            />
          </div>
          {!form.ai_seed && (
            <div>
              <Label className="gf-overline">Content (Markdown)</Label>
              <Textarea data-testid="new-tpl-content" rows={8} value={form.content} onChange={up("content")}
                className="gf-sharp mt-2 border-zinc-300 bg-white font-mono text-xs"
                placeholder="# Title&#10;&#10;Body…" />
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}
              className="gf-sharp border-zinc-300 uppercase font-bold tracking-wide">Cancel</Button>
            <Button type="submit" disabled={busy} data-testid="new-tpl-submit"
              className="gf-sharp bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide">
              {busy ? "Creating…" : "Create"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
